import CalendarView from '@/components/calendar/CalendarView'
import { expandApprovedLeaveRequestsToDates } from '@/lib/time'
import { useTRPC } from '@/trpc/react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

export const Route = createFileRoute('/dashboard/employee/calendar/')({
  component: RouteComponent,
  validateSearch: type({
    view: 'string = "month"',
  }),
})

function RouteComponent() {
  const { view } = Route.useSearch()
  const api = useTRPC()

  const { data: requests } = useQuery({
    ...api.leave.getMyLeaveRequests.queryOptions({}),
  })

  const leaveDates = expandApprovedLeaveRequestsToDates(requests ?? [])

  return <CalendarView view={view} leaveDates={leaveDates} />
}
